import { Box, Typography as MuiTypography } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

interface HourlyRateDisplayProps {
  value?: string;
}
const HourlyRateDisplay = ({ value }: HourlyRateDisplayProps) => {
  return (
    <Box
      sx={{
        p: "8px 6px",
        background: theme.brand2[50],
        borderRadius: "6px",
        width: "fit-content",
        height: "fit-content",
      }}
    >
      <MuiTypography
        sx={{
          fontSize: "12px",
          lineHeight: "16px",
          fontWeight: "600",
          fontFamily: "Poppins",
          color: theme.brand2[850],
        }}
      >
        ${value}/Hour
      </MuiTypography>
    </Box>
  );
};

export default HourlyRateDisplay;
